<template>
  <b-modal
    v-if="fileData"
    id="modalFileInfo"
    v-model="showFileInfoModal"
    size="lg"
    hide-footer
    :modal-class="modalClass"
    content-class="p-0"
    body-class="flex-grow-1 pb-sm-0 pb-1"
    @hidden="resetModal"
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title">
        Thông tin file
      </h5>
      <div>
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click="close()"
        />
      </div>
    </template>

    <div class="file-content">
      <div class="d-flex flex-column justify-content-center align-items-center pt-1 pt-md-1">
        <div class="preview-content position-relative">
          <b-button
            variant="flat-dark"
            size="sm"
            class="d-block mx-auto mb-1"
            @click="openPreviewFile"
          >
            <feather-icon
              icon="ZoomInIcon"
              class="cursor-pointer me-50"
            />
            Mở rộng
          </b-button>
          <img
            v-if="fileData.type === 'image'"
            :src="fileData.file_local"
            class="image-thumb"
          >
          <audio
            v-else-if="fileData.type === 'audio'"
            ref="audioPlayer"
            :src="fileData.file_local"
            class="audio-player"
            controls
            autoplay
            preload="auto"
            width="100%"
          />
          <video
            v-else-if="fileData.type === 'video'"
            ref="videoPlayer"
            :src="fileData.file_local"
            class="video-player"
            controls
            autoplay
            preload="auto"
            width="100%"
          />
          <feather-icon
            v-else
            icon="FileIcon"
            class="font-large-3"
          />
        </div>

        <div class="mb-1 mt-1 d-flex align-items-center w-100">
          <div
            v-if="!isEdit"
            class="flex-fill d-flex align-items-center justify-content-center"
          >
            {{ fileData.name }}
            <b-button
              size="sm"
              class="btn-icon ml-1"
              variant="outline"
              title="Sửa"
              @click="showEdit"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
          </div>
          <div
            v-else
            class="flex-fill"
          >
            <b-input-group class="input-group-merge">
              <b-form-input
                ref="inputEditFilename"
                v-model="oldFilename"
                class="pr-1"
                @keyup.enter="doEdit"
              />
              <b-input-group-append
                is-text
                @click="doEdit"
              >
                <feather-icon
                  icon="CheckIcon"
                  class="cursor-pointer font-medium-3 text-primary"
                  title="Lưu"
                />
              </b-input-group-append>
              <b-input-group-append
                is-text
                @click="cancelEdit"
              >
                <feather-icon
                  icon="XIcon"
                  class="cursor-pointer font-medium-3 text-danger"
                  title="Hủy"
                />
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>

        <div class="mb-0 mt-2 text-center text-wrap">
          <b-badge
            :variant="getMamStatusVariant(fileData.mam_status)"
            pill
            class="badge-round mr-1"
          >
            {{ getMamStatusName(fileData.mam_status) }}
          </b-badge>
        </div>
        <div
          v-if="fileData.mam_status === 1"
          class="mt-2"
        >
          <b-button
            v-if="fileData.file_proxy"
            variant="flat-dark"
            size="sm"
            :disabled="isDownloading"
            :class="{ 'btn-disabled': isDownloading }"
            @click="downloadFile"
          >
            <feather-icon
              icon="DownloadIcon"
              class="cursor-pointer me-50"
            />
            Tải file đã trancode
          </b-button>
          <b-button
            variant="flat-dark"
            size="sm"
            :disabled="isDownloading"
            @click="downloadFileOrigin"
          >
            <feather-icon
              icon="DownloadIcon"
              class="cursor-pointer me-50"
            />
            Tải file gốc
          </b-button>
        </div>
        <div
          v-if="isDownloading"
          class=" w-100 badge badge-secondary download-progress"
        >
          <div class="d-flex align-item-center justify-content-between text-white p-05">
            <span class="download-label">Đang tải file</span>
            <feather-icon
              icon="XIcon"
              class="cursor-pointer me-50"
              @click="stopDownload"
            />
          </div>
          <b-progress
            :max="downloadTotal"
            class="progress-bar-info"
          >
            <b-progress-bar
              :value="downloaded"
              :label="`${((downloaded / downloadTotal) * 100).toFixed(2)}%`"
              variant="info"
            />
          </b-progress>
        </div>
      </div>
      <!-- <h6 class="file-manager-title my-2">
        Thiết lập
      </h6>
      <ul class="list-unstyled">
        <li class="d-flex justify-content-between align-items-center mb-1">
          <span>Chia sẻ</span>
          <b-form-checkbox
            checked="true"
            name="check-button"
            label=""
            switch
            inline
          />

        </li>
        <li class="d-flex justify-content-between align-items-center mb-1">
          <span>Đã đồng bộ</span>
          <b-form-checkbox
            name="check-button"
            label=""
            switch
            inline
          />
        </li>
        <li class="d-flex justify-content-between align-items-center mb-1">
          <span>Lưu trữ</span>
          <b-form-checkbox
            name="check-button"
            label=""
            switch
            inline
          />
        </li>
      </ul>
      <hr class="my-2"> -->
      <h6 class="file-manager-title font-weight-bolder my-2">
        Thông tin
      </h6>
      <ul class="list-unstyled">
        <li class="d-flex justify-content-between align-items-center">
          <p>Loại</p>
          <p class="fw-bold">
            {{ fileData.extension }}
          </p>
        </li>
        <li class="d-flex justify-content-between align-items-center">
          <p>Size</p>
          <p class="fw-bold">
            {{ convertSize(fileData.filesize) }}
          </p>
        </li>
        <li class="d-flex justify-content-between align-items-center">
          <p>Thư mục</p>
          <p class="fw-bold">
            <!-- Files > Documents -->
            {{ fileData.category_name }}
          </p>
        </li>
        <li class="d-flex justify-content-between align-items-center">
          <p>Người tạo</p>
          <p class="fw-bold">
            {{ fileData.created_by }}
          </p>
        </li>
        <!-- <li class="d-flex justify-content-between align-items-center">
          <p>Thay đổi cuối</p>
          <p class="fw-bold">
            {{ convertDate(fileData.updated_at) }}
          </p>
        </li> -->

        <li class="d-flex justify-content-between align-items-center">
          <p>Tạo lúc</p>
          <p class="fw-bold">
            {{ convertDate(fileData.created_at) }}
          </p>
        </li>
      </ul>
      <hr class="my-2">
      <b-button
        v-if="isAllowOpenEditor"
        variant="outline-primary"
        size="sm"
        class=" mr-1"
        :disabled="loading"
        @click="openAudioEditor"
      >
        <feather-icon
          icon="EditIcon"
          class="cursor-pointer me-50"
        />
        Biên tập
      </b-button>
      <b-button
        variant="danger"
        :disabled="loading"
        size="sm"
        @click="deleteFile"
      >
        <feather-icon
          icon="TrashIcon"
          class="cursor-pointer me-50"
        />
        Xóa
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BBadge,
  BProgress,
  BFormInput,
  BProgressBar,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
// import axios from '@axios';
import axios from 'axios';
import { showToast } from '@/@core/utils/utils';
import { ref } from '@vue/composition-api';
import useFiles from '../useFiles';

export default {
  components: {
    BButton,
    BBadge,
    BProgress,
    BProgressBar,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
  },
  props: {
    fileData: {
      type: Object,
      default: null,
    },
    modalClass: {
      type: String,
      default: 'modal modal-slide-in fade file-info-modal',
    },
  },
  data() {
    return {
      loading: false,
      downloaded: 0,
      downloadTotal: 0,
      isDownloading: false,
      isEdit: false,

    }
  },
  setup(props) {
    const downloadFileController = new AbortController();
    const oldFilename = ref('');
    const {
      statusNames,
      statusVariants,
      mamStatusNames,
      mamStatusVariants,
      getMamStatusVariant,
      getMamStatusName,
      convertSize,
      convertDate,
    } = useFiles();

    return {
      statusNames,
      statusVariants,
      mamStatusNames,
      mamStatusVariants,
      getMamStatusVariant,
      getMamStatusName,
      convertSize,
      convertDate,
      oldFilename,
      downloadFileController,
    }
  },
  computed: {
    // editFilename: {
    //   get() {
    //     return this.fileData.name;
    //   },
    //   set(val) {
    //     console.log('val', val);
    //     Vue.set('editFilename', val)
    //   },
    // },
    isAllowOpenEditor() {
      console.log('this.fileData', this.fileData);
      console.log('isAllowOpenEditor', /(mp3|wav)$/.test(this.fileData.extension));
      return /(mp3|wav)$/.test(this.fileData.extension);
    },
    showFileInfoModal: {
      get() {
        return this.$store.state.files.show_file_info_modal;
      },
      set(newVal) {
        // console.log('set showFileInfoModal', newVal);
      },
    },
  },
  mounted() {
    this.isDownloading = false;
    this.downloaded = 0;
    this.downloadTotal = 0;
  },
  methods: {
    openPreviewFile() {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.pause()
      }
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause()
      }
      this.$emit('open-preview-file')
    },
    openAudioEditor() {
      this.resetModal();
      this.$emit('open-audio-editor')
    },

    resetModal() {
      this.$store.dispatch('files/setState', { show_file_info_modal: false });
    },
    deleteFile() {
      // console.log('deleteFile', this.fileData);
      if (this.fileData) {
        this.loading = true;
        this.$store.dispatch('files/destroyFile', { id: this.fileData.id })
          .then((res) => {
            this.loading = false;
            if (res.status === 200) {
              if (res.data.code === 200) {
                this.resetModal();
                this.$store.dispatch('files/setState', { show_all_category: (new Date()).getTime() });
              }
            }
            this.$store.dispatch('files/setState', { loading: false });
          });
      }
    },
    isValidUrl(urlString) {
      const urlPattern = new RegExp('^(https?:\\/\\/)?' // validate protocol
        + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // validate domain name
        + '((\\d{1,3}\\.){3}\\d{1,3}))' // validate OR ip (v4) address
        + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // validate port and path
        + '(\\?[;&a-z\\d%_.~+=-]*)?' // validate query string
        + '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
      return !!urlPattern.test(urlString);
    },
    downloadFile(e, type) {
      const url = type === undefined || type === 'proxy' ? this.fileData.file_proxy : this.fileData.file_original;
      let filename = `${this.fileData.name}.${this.fileData.extension}`;
      if (type === 'original' && filename == '') {
        filename = this.fileData.file_local;
      }
      // console.log(`downloadFile ---> type: ${type}`, `filename: ${filename}`);
      if (url === '' || !this.isValidUrl(url)) {
        showToast('Không tìm thấy file');
      } else {
        // console.log('this.fileData', this.fileData);
        // console.log('url', url);
        // console.log('filename', filename);

        const vm = this;
        const config = {
          method: 'get',
          url,
          responseType: 'blob',
          // responseType: 'stream',
          onDownloadProgress(progressEvent) {
            const { loaded, total } = progressEvent;
            vm.downloaded = loaded;
            vm.downloadTotal = total;
            // console.log(vm.downloaded, vm.downloadTotal);
            const percent = Math.floor((loaded * 100) / total);
            if (percent < 100) {
              // console.log(`Downloaded ${loaded} bytes of ${total} bytes. ${percent}%`);
            } else {
              vm.isDownloading = false;
            }
          },
        }
        vm.isDownloading = true;
        vm.downloaded = 0;
        vm.downloadTotal = 0;
        axios(config, {
          signal: this.downloadFileController.signal,
        }).then((response) => {
          // create file link in browser's memory
          const href = URL.createObjectURL(response.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', filename); // or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        });
      }
    },
    downloadFileOrigin(e) {
      this.downloadFile(e, 'original')
    },
    stopDownload() {
      this.downloadFileController.abort();
    },
    doEdit() {
      if (this.loading) {
        return;
      }
      if (!this.fileData.version_id) {
        return showToast('File đang trancode vui lòng quay lại sau');
      }
      if (this.oldFilename === '') {
        showToast('Tên file không được để trống');
        this.$refs.inputEditFilename.$el.focus();
      } else if (this.oldFilename === this.fileData.name) {
        this.isEdit = false;
      } else {
        this.loading = true;
        this.$store.dispatch('files/updateFile', { data: { name: this.oldFilename }, id: this.fileData.id })
          .then((res) => {
            this.loading = false;
            if (res.status === 200) {
              if (res.data.code === 200) {
                this.isEdit = false;
                this.fileData.name = this.oldFilename;
              }
            }
          });
      }
    },
    cancelEdit() {
      this.isEdit = false;
      this.oldFilename = this.fileData.name;
    },
    showEdit() {
      if (this.oldFilename === '') {
        this.oldFilename = this.fileData.name;
      }
      this.isEdit = true
    },
  },
}
</script>

<style lang="scss" scoped>
.file-content {
  .btn-disabled {
    background-color: rgba(75, 75, 75, 0.12);
  }

  .text-wrap {
    word-wrap: break-word;
  }
}
</style>
